import { Component, Input, OnInit } from '@angular/core';
import { UtilService } from '../../shared/services';

@Component({
  selector: 'app-homepage-nudge',
  templateUrl: './homepage-nudge.component.html',
  styleUrls: ['./homepage-nudge.component.scss']
})
export class HomepageNudgeComponent implements OnInit {

  @Input() fundraiser;
  @Input() animation;
  isMobile;

  constructor(
    public util: UtilService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.util?.isMobile();
  }

}
